/**
 * Sprites are palette-indexed text grids authored in-repo (CREDITS.md:
 * no binary assets). Each character indexes a semantic palette slot in
 * base-36 ('0'-'9', 'a'-'z'); '.' is transparent. Semantic slots are the
 * whole trick: swapping the palette instance recolors coats, silks, and
 * track conditions with zero extra art.
 */
export interface SpriteDef {
  name: string;
  w: number;
  h: number;
  /** Semantic slot names; a grid char is an index into this list. */
  paletteSlots: string[];
  /** frames → rows; every row is exactly `w` chars, `h` rows per frame. */
  frames: string[][];
  /** Pixel the sprite is positioned by (e.g. hoof line center). */
  anchor: [number, number];
  /** Default playback for ambient loops; race gallop is distance-driven. */
  fps?: number;
}

export interface PaletteInstance {
  id: string;
  /** Slot index → 0xRRGGBB. */
  colors: number[];
}

export const TRANSPARENT = '.';

export function slotChar(index: number): string {
  return index.toString(36);
}

export function slotIndex(char: string): number {
  return parseInt(char, 36);
}
